import React from 'react'
import ReactModal from 'react-modal'
import { AlertTriangle } from 'lucide-react'

function CreationLimitModal({uploadNew, onClose}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}

    style={{
        overlay: {
          zIndex: 30,
          backgroundColor: 'rgba(20,33,61,.4)'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '420px',
            width: '90vw',
            padding: '36px 32px',
            border: '1px solid rgba(20,33,61,.14)',
            borderRadius: '14px',
            backgroundColor: '#fffdf8',
            boxShadow: '0 12px 32px rgba(20,33,61,.3)',
        }
      }}
    >
        <div className='flex items-center flex-col text-center font-plexsans'>
            <div className='flex items-center justify-center w-12 h-12 rounded-full bg-[rgba(109,76,37,.12)] mb-4'>
                <AlertTriangle className='w-6 h-6 text-tanDark' />
            </div>

            <div className='font-spectral text-navy text-[19px] font-semibold leading-snug'>
                You can only have 3 open cases at one time
            </div>

            <div className='text-[13px] text-[rgba(20,33,61,.6)] leading-relaxed mt-3'>
                To create a new case, you can delete one of your existing open cases.
            </div>

            <div className='flex flex-col w-full gap-2.5 mt-7'>
                <div
                className='w-full text-center rounded-lg py-3 font-semibold text-[13.5px] bg-tan text-white cursor-pointer hover:bg-tanDark transition-colors'
                onClick={onClose}>
                    Go back
                </div>
            </div>
         </div>
    </ReactModal>
  )
}

export default CreationLimitModal;
